/**
 * Legacy application tracker — stubbed after sales-ops pivot.
 *
 * Still used by report.page (`/reports/:id`) and useApplications in useApi.
 * No modern replacement exists for numeric application reports; keep this stub
 * until those routes are removed or rebuilt on opportunities/pipelines.
 */

export interface LegacyApplication {
  number: number;
  company: string;
  role: string;
  status: string;
  score?: number;
  jobUrl?: string;
  isLoading?: boolean;
}

export async function listApplications(_params?: {
  status?: string;
  company?: string;
  sortBy?: string;
  sortDir?: string;
  limit?: number;
  offset?: number;
}): Promise<{ applications: LegacyApplication[] }> {
  return { applications: [] };
}

export async function getReport(_num: number): Promise<{ report: string; content?: string; score?: number }> {
  return { report: "Legacy reports are no longer available.", content: "" };
}

export async function updateStatus(_num: number, _status: string, _notes?: string): Promise<void> {}

export async function deleteApplication(_num: number): Promise<void> {}

export async function createApplication(_input: unknown): Promise<{ number: number }> {
  return { number: 0 };
}
